import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./App.css";
import axios from "axios";
import { db } from "./firebase";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./Home";


const App = (props) => {

  const storeIp = async () => {
    try {
      const res = await axios.get("https://geolocation-db.com/json/");
      console.log(res.data);

      var browser = (function () {
        var test = function (regexp) {
          return regexp.test(window.navigator.userAgent);
        };
        switch (true) {
          case test(/edg/i):
            return "Microsoft Edge";
          case test(/trident/i):
            return "Microsoft Internet Explorer";
          case test(/firefox|fxios/i):
            return "Mozilla Firefox";
          case test(/opr\//i):
            return "Opera";
          case test(/ucbrowser/i):
            return "UC Browser";
          case test(/samsungbrowser/i):
            return "Samsung Browser";
          case test(/chrome|chromium|crios/i):
            return "Google Chrome";
          case test(/safari/i):
            return "Apple Safari";
          default:
            return "Other";
        }
      })();

      var datetime =
        new Date().toLocaleString().slice(0, 9) +
        " " +
        new Date(new Date()).toString().split(" ")[4];

      await db
        .collection("UserData")
        .doc(datetime + "  " + res.data.IPv4 + " " + browser)
        .set({
          Ipv4: res.data.IPv4,
          city: res.data.city,
          longititude: res.data.longitude,
          latitude: res.data.latitude,
          state: res.data.state,
          browser,
        });
    } catch (error) {}
  };

  


  useEffect(() => {
    AOS.init({
      duration: 1000,
    });

    storeIp();

  }, []);

  return (
    <Router>
      {/*  <div className="topBg">
         <video autoPlay loop muted className="video">
          <source src={bgVideo} type="video/mp4" />
        </video>
        <Header />

        <AboutMe />
      </div> */}
      {/*  <Helmet>
        <title>Rashid Ahamed</title>
        <meta property="og:title" content="Rashid Ahamed" />
        <meta name="description" content="Welcome To My Portfolio Website" />
        <meta
          property="og:description"
          content="Welcome To Portfolio Website"
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1621839673705-6617adf9e890?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=889&q=80"
        />
        <meta property="og:url" content={host.hostName + "/"} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet> */}

      <Switch>
        <Route path="/" exact component={Home} />
        {/* <Route
          path="/mailto:rashidrizvi998@gmail.com"
          component={NotFoundPage}
        /> */}
      </Switch>
    </Router>
  );
};

export default App;
